import { Outlet, useLocation } from 'react-router-dom';

import NavTopBar from 'components/NavTopBar';

const MainLayout = () => {
  const location = useLocation();
  const usesCommandCenterShell =
    location.pathname.startsWith('/dashboard') ||
    location.pathname.startsWith('/management') ||
    location.pathname.startsWith('/help');

  return (
    <div className="font-nunito min-h-screen bg-gray-100">
      {!usesCommandCenterShell && <NavTopBar />}
      <main className={usesCommandCenterShell ? '' : 'pt-16'}>
        <div className={usesCommandCenterShell ? '' : 'p-4'}>
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default MainLayout;
